<template>
  <div class="error-page">
    <div class="error-code">4<span>0</span>3</div>
    <div class="error-desc">抱歉~ 您的权限不足，请联系管理员！</div>
    <div class="error-handle">
      <router-link to="/login">
        <el-button size="large" type="primary" @click="backLogin"
        >返回登录
        </el-button
        >
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    function backLogin() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }

    return {
      backLogin,
    };
  },
};
</script>


<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}

.error-code {
  line-height: 1;
  font-size: 100px;
  font-weight: bolder;
  color: #2d8cf0;
}

.error-code span {
  color: #00a854;
}

.error-desc {
  font-size: 30px;
  color: #777;
}

.error-handle {
  margin-top: 30px;
  padding-bottom: 200px;
}

.error-btn {
  margin-left: 100px;
}
</style>
